import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    imageWrapper: {
      "& > img": {
        display: "block",
        border: 0,
        margin: 0,
        padding: 0,
        lineHeight: 0,
      },
    },
  },
  { name: "N0Icon" },
);

export { useStyles };
